import { useEffect, useState } from "react";
import axios from "axios";
import { Newspaper } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import BlogCard from "@/components/BlogCard";
import { API } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState(null);

  useSEO({
    title: "ბლოგი — რჩევები ტაქსის მძღოლებისთვის | taxipark.ge",
    description: "სასარგებლო სტატიები ტაქსის მძღოლებისთვის: საწვავის დაზოგვა, ტარიფები, ელექტრო და ჰიბრიდი ავტომობილები ტაქსისთვის, შემოსავლის გაზრდის რჩევები.",
    path: "/blog",
  });

  useEffect(() => {
    axios.get(`${API}/blog`).then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []);

  return (
    <main className="min-h-screen bg-[#0A0B0E] pt-28 pb-20" data-testid="blog-page">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12">
        <Breadcrumbs items={[{ name: "მთავარი", path: "/" }, { name: "ბლოგი", path: "/blog" }]} />
        <p className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] font-semibold mb-3">ბლოგი</p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">სიახლეები და რჩევები მძღოლებისთვის</h1>
        <p className="text-lg text-gray-400 mt-4 max-w-2xl leading-relaxed">
          პრაქტიკული სტატიები ტაქსში მუშაობის, საწვავის დაზოგვისა და შემოსავლის გაზრდის შესახებ.
        </p>

        <div className="mt-12">
          {posts === null ? (
            <p className="text-gray-500">იტვირთება...</p>
          ) : posts.length === 0 ? (
            <div className="card-lux p-12 text-center" data-testid="blog-empty">
              <Newspaper className="w-10 h-10 text-gray-600 mx-auto mb-4" />
              <p className="text-gray-400">სტატიები მალე დაემატება.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
              {posts.map((p, i) => (
                <BlogCard key={p.id} post={p} index={i} />
              ))}
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
